import { ISessionSettings } from "@webapp/sessions/models/sessions.model";
import { ISessionSettingsUI } from "./methodology-section.component";

export const toSessionUISettings = (settings: ISessionSettings): ISessionSettingsUI => {
  return {
    assignGoalPermissions: settings.assignGoalPermissions,
    assignMetricPermissions: settings.assignMetricPermissions,
    multipleOwnersEnabledForGoals: !settings.multipleOwners.disabledForGoals,
    multipleOwnersEnabledForMetrics: !settings.multipleOwners.disabledForMetrics,
    progressAggregationEnabled: !settings.progressAggregationDisabled,
    metricsLimit: settings.metricsPerGoalLimit,
    goalsLimit: settings.goalsPerOwnerLimit,
  };
};

export const toSessionSettings = (settings: ISessionSettingsUI): ISessionSettings => {
  return {
    assignGoalPermissions: settings.assignGoalPermissions,
    assignMetricPermissions: settings.assignMetricPermissions,
    multipleOwners: {
      disabledForGoals: !settings.multipleOwnersEnabledForGoals,
      disabledForMetrics: !settings.multipleOwnersEnabledForMetrics,
    },
    progressAggregationDisabled: !settings.progressAggregationEnabled,
    metricsPerGoalLimit: settings.metricsLimit,
    goalsPerOwnerLimit: settings.goalsLimit,
  };
};
